import { render, staticRenderFns } from "./custom-rule-wrapper.vue?vue&type=template&id=c2d63708"
import script from "./custom-rule-wrapper.vue?vue&type=script&lang=ts"
export * from "./custom-rule-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports